import { render, staticRenderFns } from "./IconCollapse.vue?vue&type=template&id=766b5cce&scoped=true"
import script from "./IconCollapse.vue?vue&type=script&lang=js"
export * from "./IconCollapse.vue?vue&type=script&lang=js"
import style0 from "./IconCollapse.vue?vue&type=style&index=0&id=766b5cce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766b5cce",
  null
  
)

export default component.exports